/** The card every list row sits in; pending rows reuse it to match. */
export const LIST_ROW = 'p-3 rounded-xl bg-card border border-border'

/** Press feedback for rows that are links. */
export const LIST_ROW_PRESS = 'active:scale-[0.98] transition-transform'
